/**
 * 텍스트 전체 하이라이트
 * (e.g. 학습자, 상위25%, 원어민)
 */

interface IHighlightedTextProps {
  text: string | number
  color: string //hex color
}

const HighlightedText = ({ text, color }: IHighlightedTextProps) => {
  return (
    <p className="relative">
      <span
        className="text-sTitle box-decoration-clone font-bold text-gray-700 underline decoration-[10px] underline-offset-[-8px]"
        style={{
          textDecorationSkipInk: 'none',
          textDecorationColor: color,
        }}
      >
        {text}
      </span>
    </p>
  )
}

export default HighlightedText
